function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 48 48"
}, props), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M0 40.5v-12C0 15.65 5.98 6.34 18.17 3.08A2.25 2.25 0 0121 5.25v3.18c0 .94-.58 1.8-1.47 2.11-6.19 2.24-9.78 6.52-9.78 13.46h6.75a4.5 4.5 0 014.5 4.5v12a4.5 4.5 0 01-4.5 4.5h-12A4.5 4.5 0 010 40.5zM31.5 45h12a4.5 4.5 0 004.5-4.5v-12a4.5 4.5 0 00-4.5-4.5h-6.75c0-6.94 3.6-11.22 9.78-13.46A2.24 2.24 0 0048 8.43V5.25a2.25 2.25 0 00-2.83-2.17C32.98 6.34 27 15.65 27 28.5v12a4.5 4.5 0 004.5 4.5z"
})));